<template>
<div class="text-segment-list"> 
     <div v-if="lesson">
        <div v-for="(segment,si) in lesson.segments" :key="si"> 
            <div v-if="segment.type=='text'">  
                <tip-tap-viewer class="text-segment-viewer" v-model="textItem.text" v-for="(textItem, ti) in segment.config.cardConfig.items" :key="ti"   /> 
            </div>
            <div v-if="segment.type!='text'" class="ProseMirror">
                <h3>{{segment.name}}</h3>
                <table v-if="!renderAsTiles(segment)" >
                    <tr v-for="(term,ti) in segment.terms" :key="ti">
                        <td><term-button class="btn-play badge round"  :tid="term.tid" /></td>
                        <td>{{term.text}}</td>
                        <td>{{getTranslation(term)}}</td>
                    </tr>
                </table>
                <div v-if="renderAsTiles(segment)" class="d-flex" > y
                     <div v-for="(term,ti) in segment.terms" :key="ti" class="tile-item">
                        <div class="picture" :style="getBackgroundImage(term)"></div>
                        <term-button class="btn-play" :autoLoad="false"  :tid="term.tid" >{{term.text}}</term-button>
                        <div class="p2"><i>{{getTranslation(term)}}</i></div> 
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>
</template>

<script lang="ts">
import { Options, Inject,Prop, Vue, Watch, Provide } from 'vue-property-decorator';
import { CourseRepository, Lesson, Segment } from '@/data/repository/CourseRepository';
//const TipTapViewer = () => import('@/components/tiptap/TipTapViewer.vue').then(module=> module.default);
import  TipTapViewer  from '@/components/tiptap/TipTapViewer.vue'; 
import { TermDetail } from '@/data/model/Entry';
import TermButton from '@/components/core/TermButton.vue'; 
import { EmurseContext } from '@/EmurseCore';

class PrintableLessonViewModel
{

}

@Options({components:{TipTapViewer, TermButton}})
export default class PrintableLesson extends Vue {

    @Inject() courseRepository!: CourseRepository; 
    //@Provide("emurseContext") emurseContext: EmurseContext = new EmurseContext("print",false); 
    @Prop({default:""}) lessonUid!: string;

    public segments: Segment[] =[];
    public lesson: Lesson | null = null;
 
    @Watch("lessonUid") 
    public uidChanged()
    {
        if (this.lessonUid)
        {
           this.courseRepository.getLessonWithSegmentDetailByUid({uid:this.lessonUid}).then(lessonData=>{
               this.lesson=lessonData.lesson;
           })
        } 
    }

    public getImage(term: TermDetail): any 
    {
        if (term.images) {
            return term.images[0];
        }

        return null;
    }

    public getBackgroundImage(term: TermDetail)
    {
       const image = this.getImage(term);

        if (image) {
            return `background-image:url('${image.sizes.tn}')`
        }

        return '';
    }

    public renderAsTiles(segment: Segment)
    {
        const s: any = segment;
        return (s.config &&
            s.config.cardConfig &&
            s.config.cardConfig.front  &&
             s.config.cardConfig.front.showPicture);

        //  return (segment.terms && segment.terms[0].images && segment.terms[0].images[0])
    }

    public getTranslation(term: TermDetail)
    {
        if (term.translation) {
            return term.translation
        }
        else if (term.entryTranslation) {
            return term.entryTranslation.directTranslation;
        }
    }
 
    public mounted()
    {
       this.uidChanged();
    }
}
</script>


<style lang="scss">
  @import '@/theme/_helpers.scss';

 .text-segment-list 
 {
    .tiptap.text-segment-viewer .ProseMirror 
    {
        background: none;
        margin:none;
        border:none !important; 
    }

    .tiptap.text-segment-viewer:nth-child(odd)
    {
         background: $gray-200;
    }

          table {
         td,th {
           border:1px solid;
           padding:.50rem;
           vertical-align: middle;

           p,span {
             padding:0;
             margin:0;
           }
 

         }
      }

      .tile-item {
          display: flex;
          align-items: center;
          flex-direction:column;
          border: $gray-200 .25rem solid;
          padding:1rem;
          margin-right: 1rem;
          margin-bottom: 1rem;
      }

      .picture {
          width:5rem;
          height: 5rem;
          background-repeat: no-repeat;
          background-size: contain;
      }
 }

</style>
